import { Object } from "core-js";

export default Object.freeze({
    ADDRESS: 'ADDRESS',
    LOCKER: 'LOCKER',
    POSTOFFICE: 'POSTOFFICE',
    KEEPITEMS: 'KEEPITEMS',
});